// @flow

import { type IncomingPayment, getCountry, getMerchant } from '@tectonics/prs/incoming-payment';
import { getPublicIntegrationKey, getLookAndFeel } from '@tectonics/prs/merchant';

/* global COMMITHASH */

export function sendGA4Event(eventName: string, eventParams: { [string]: mixed } = {}) {
  try {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, eventParams);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('GA4 sendGA4Event error:', e);
  }
}

export function buildCommonEventParams(payment: IncomingPayment): { [string]: mixed } {
  try {
    const merchant = getMerchant(payment);

    return {
      merchant_id: getPublicIntegrationKey(merchant),
      checkout_country: getCountry(payment),
      payment_method: payment.payment_type_code || '',
      environment: ENV_CONSTANTS.ENV,
      checkout_version: typeof COMMITHASH === 'string' ? COMMITHASH : '',
      look_and_feel: getLookAndFeel(merchant),
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('GA4 buildCommonEventParams error:', e);
    return {};
  }
}
